// Card #1797 — the Blank mode type: a single logo, centred on both axes,
// on an otherwise empty board (design pare-down, 2026-08-20).
//
// This is #1798's universal "nothing to show" fallback (Jaybill,
// 2026-08-20: "NEVER show an error message on the scoreboard") — so unlike
// every other layout in this directory, it must be safe to render from
// LITERALLY nothing: no `fields`, no `payload`, no class, no ride, not even
// a successful poll. Accordingly it takes exactly one prop, a bare
// `logoAssetUrl` string that may be absent/unresolved/garbage (card #2308:
// score-api resolves a mode's org-scoped logoAsset id into this URL
// server-side, falling back to null on any miss), and resolves it through
// blankLogoAssets.js's fallback — never trusts it as a path beyond a plain
// <img> src, and can't throw on any input (see that file's
// resolveBlankLogoAsset). ScoreboardContent.jsx dispatches here for
// LAYOUT_FAMILY.BLANK BEFORE its shared "no fields yet" empty-state gate,
// specifically so this never needs a composed response to render.
import { resolveBlankLogoAsset } from "./blankLogoAssets";
import "./BlankLayout.css";

export default function BlankLayout({ logoAssetUrl }) {
  return (
    <div className="scoreboard-blank" data-testid="scoreboard-blank">
      {/* alt="" — decorative on a board nobody reads with a screen reader;
          the src itself can never be broken (see resolveBlankLogoAsset). */}
      <img
        className="scoreboard-blank__logo"
        src={resolveBlankLogoAsset(logoAssetUrl)}
        alt=""
        data-testid="scoreboard-blank-logo"
      />
    </div>
  );
}
